import { Helmet } from 'react-helmet'
import { PosLogExportButton, PosLogTable } from 'components/logsPos'

const PosApi = () => {
  return (
    <>
      <Helmet>
        <title>ORMS POS API Logs </title>
      </Helmet>

      <PosLogExportButton />
      <PosLogTable />
    </>
  )
}

export default PosApi
